import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  icon: '📥',
  q: 'Come ricevo il materiale?',
  a: 'Immediatamente dopo il pagamento ricevi un link per scaricare tutti i file in PDF, Word ed Excel. Accesso immediato, nessuna attesa. Puoi usare i materiali già dalla prossima lezione.'
}, {
  icon: '📚',
  q: 'È adatto sia per il Biennio che per il Triennio?',
  a: "Sì. Il Metodo copre l'intero percorso ITE: dal Biennio al Triennio, dalla Partita Doppia alla Seconda Prova della Maturità. Ogni volume è pensato per un livello progressivo."
}, {
  icon: '🖨️',
  q: 'I materiali sono stampabili?',
  a: 'Sì. Tutti i file PDF sono ottimizzati per la stampa in formato A4. Puoi anche proiettarli direttamente sulla LIM senza modifiche.'
}, {
  icon: '🏛️',
  q: 'La valutazione è conforme alle linee guida MIM?',
  a: "Sì. Ogni griglia e rubrica di valutazione è strutturata secondo le Indicazioni Nazionali e il Quadro di Riferimento del Ministero dell'Istruzione e del Merito 2025/2026."
}, {
  icon: '🎓',
  q: 'Per quali classi è pensato il Metodo?',
  a: 'Per tutte le classi degli Istituti Tecnici Economici (ITE): dalla prima alla quinta, con percorsi graduati per livello e anno scolastico.'
}, {
  icon: '♿',
  q: 'Posso utilizzarlo anche con studenti DSA o BES?',
  a: 'Sì. Il Bonus 3 include griglie differenziate, mappe compensative e template PDP già strutturati per ogni unità didattica, conformi alla Legge 170/2010.'
}, {
  icon: '⏳',
  q: 'Quanto tempo ho per scaricare i materiali?',
  a: 'Accesso a vita. Non ci sono scadenze. Puoi scaricare e usare i materiali quando vuoi, per tutti gli anni scolastici futuri.'
}, {
  icon: '📅',
  q: 'Posso usare i contenuti per più anni scolastici?',
  a: 'Sì. Una volta acquistato il Metodo, puoi riutilizzare tutti i materiali ogni anno scolastico senza costi aggiuntivi.'
}, {
  icon: '🛡️',
  q: 'Come funziona la garanzia di 14 giorni?',
  a: "Se entro 14 giorni dall'acquisto non sei soddisfatto, scrivi una email a kitonline27@gmail.com e ricevi il rimborso completo in 24 ore. Nessuna domanda, nessuna burocrazia."
}, {
  icon: '🔒',
  q: 'Quali metodi di pagamento accettate?',
  a: 'Pagamento sicuro tramite Stripe con crittografia SSL. Accettiamo tutte le carte di credito e debito, PayPal e Apple Pay. Nessun costo nascosto. Pagamento unico.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-14 px-4 bg-brand-dark" data-id="element-98">
      <div className="max-w-3xl mx-auto" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-100">
          <p className="text-xs font-black uppercase tracking-widest text-brand-orange mb-3" data-id="element-101">
            Domande Frequenti
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-brand-cream leading-tight" data-id="element-102">
            Tutto quello che devi{' '}
            <span className="bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent" data-id="element-103">
              sapere
            </span>
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-104">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-brand-card border border-white/10 rounded-xl overflow-hidden" data-id="element-105">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 sm:px-6 sm:py-5 text-left flex justify-between items-center hover:bg-white/5 transition-colors gap-3" data-id="element-106">
                <span className="font-bold text-brand-cream pr-2 flex items-center gap-2 text-sm sm:text-base" data-id="element-107">
                  <span className="text-lg" data-id="element-108">{faq.icon}</span>
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-orange transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-109" />
              </button>

              <AnimatePresence data-id="element-110">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-111">
                    <div className="px-5 pb-5 sm:px-6 sm:pb-5 pt-0 text-gray-400 font-medium leading-relaxed text-sm sm:text-base" data-id="element-112">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}